import React from 'react';
import styles from './DataBox.module.css';
import { formatValue } from '../../../utils/formats';

function DataBox({ title, description, data = [], columns = [], onRowAction = null }) {
  return (
    <div className={styles.dataBox}>
      <div className={styles.header}>
        <h3 className={styles.title}>{title}</h3>
        {description && <p className={styles.description}>{description}</p>}
      </div>
      <div className={styles.content}>
        <table className={styles.table}>
          <thead>
            <tr>
              {columns.map((col, index) => (
                <th key={index}>{col.header}</th>
              ))}
              {onRowAction && <th>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {columns.map((col, colIndex) => (
                    <td key={colIndex}>
                      {formatValue(row[col.accessor], col.format)}</td>
                  ))}
                  {onRowAction && (
                    <td>
                      <button onClick={() => onRowAction(row)}>Generate</button>
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length + (onRowAction ? 1 : 0)} style={{ textAlign: 'center', padding: '1rem' }}>
                  No data found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DataBox;
